import { Injectable } from '@angular/core';
import {
  ICON_REGISTRY,
  IconDefinition,
  IconDefinitionInput,
  IconName,
  IconState,
} from './icon-registry';

@Injectable({
  providedIn: 'root',
})
export class IconHelperService {
  private icons: Record<string, IconDefinitionInput> = { ...ICON_REGISTRY };

  get(name: string, state: IconState = 'default'): string | null {
    const definition = this.toDefinition(this.icons[name]);
    if (!definition) {
      return null;
    }
    if (state === 'selected') {
      return definition.selected || definition.default;
    }
    return definition.default;
  }

  set(name: string, svg: IconDefinitionInput): void {
    this.icons[name] = svg;
  }

  setMany(icons: Record<string, IconDefinitionInput>): void {
    this.icons = { ...this.icons, ...icons };
  }

  has(name: string): boolean {
    return !!this.icons[name];
  }

  hasSelected(name: string): boolean {
    const definition = this.toDefinition(this.icons[name]);
    return !!definition?.selected;
  }

  getAllNames(): string[] {
    return Object.keys(this.icons);
  }

  getDefaultNames(): IconName[] {
    return Object.keys(ICON_REGISTRY) as IconName[];
  }

  private toDefinition(input?: IconDefinitionInput): IconDefinition | null {
    if (!input) {
      return null;
    }
    if (typeof input === 'string') {
      return { default: input };
    }
    return input;
  }
}
